import type { HelpConfig } from '#types/config/pages/help'
import type { RecursivePartial } from '#types/utils'

export default {
  hideSidebarPaths: ['/help', '/help/all-topics']
} satisfies RecursivePartial<HelpConfig>
